// extracted by mini-css-extract-plugin
export default {"item":"MoneyItem_item__hTe6J","item__idescription":"MoneyItem_item__idescription__MQGDr","item__values":"MoneyItem_item__values__7bIDm","item__icon":"MoneyItem_item__icon__pcIAR"};